// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CL1z","col":"styles_col__3z_la"};